
const { NODE_ENV } = process.env

export const DEV = NODE_ENV === 'development' // 开发环境
export const PROD = NODE_ENV === 'production' // 生产环境


export default {
  DEV, PROD,
}